import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ManageDoctor.css";

function DoctorManagement() {
  const [doctorData, setDoctorData] = useState({
      name: "",
      specialization: "",
      mobileNum: "",
      hospitalIds: [], // Store selected hospital IDs
      image: null, // File input for image
      about: "",
    });
  const [doctors, setDoctors] = useState([]);
  const [hospitals, setHospitals] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [editingDoctor, setEditingDoctor] = useState(null);
  const [updatedName, setUpdatedName] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false); // Dropdown visibility
  const [updatedExpertise, setUpdatedExpertise] = useState("");
  const [updatedHospitals, setUpdatedHospitals] = useState("");
  const [updatedImage, setUpdatedImage] = useState(null); // To handle image updates

   useEffect(() => {
      // Fetch hospitals when component loads
      const fetchHospitals = async () => {
        try {
          const response = await axios.get(
            "https://api.swasthmitra.com/api/hospital/gethospital"
          );
          setHospitals(response.data.data);
        } catch (error) {
          setMessage({ text: "Error fetching hospitals.", type: "error" });
        }
      };
      fetchHospitals();
    }, []);
    const handleCheckboxChange = (hospitalId) => {
      setDoctorData((prevData) => {
        const isSelected = prevData.hospitalIds.includes(hospitalId);
        return {
          ...prevData,
          hospitalIds: isSelected
            ? prevData.hospitalIds.filter((id) => id !== hospitalId) // Remove if already selected
            : [...prevData.hospitalIds, hospitalId], // Add if not selected
        };
      });
    };
    console.log(doctorData.hospitalIds)
    
  

  // Fetch doctors from the API
  const fetchDoctors = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        "https://api.swasthmitra.com/api/doctor/getdoctor"
      );
      console.log(response.data);
      setDoctors(response.data.data);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch doctors. Please try again later.");
      setLoading(false);
    }
  };
  // Function to handle hospital deletion
  const handleDeleteHospital = async (index, hid, did) => {
    const updatedHospitalsList = [...editingDoctor.hospitals];
    updatedHospitalsList.splice(index, 1); // Remove hospital at the specified index
    setEditingDoctor({ ...editingDoctor, hospitals: updatedHospitalsList });
    try {
      await axios.delete(
        `https://api.swasthmitra.com/api/doctor/deleteDoctorFromHospital/${did}/${hid}`
      );
      setDoctors(doctors.filter((_, i) => i !== index));
    } catch (error) {
      console.error("Error removing doctor:", error);
      setError("Error removing doctor");
    }
  };

  // Delete doctor by ID
  const deleteDoctor = async (id) => {
    if (window.confirm("Are you sure you want to delete this doctor?")) {
      try {
        await axios.delete(
          `https://api.swasthmitra.com/api/doctor/deletedoctor/${id}`
        );
        alert("Doctor deleted successfully!");
        fetchDoctors(); // Refresh the doctor list
      } catch (err) {
        alert("Failed to delete the doctor. Please try again.");
      }
    }
  };

  // Open edit modal with current doctor data
  const openEditModal = (doctor) => {
    setEditingDoctor(doctor);
    setUpdatedName(doctor.name);
    setUpdatedExpertise(doctor.specialization);
    setUpdatedHospitals(doctor.hospitals);
    setUpdatedImage(null); // Reset image input
    setDoctorData((prevData) => ({
      ...prevData,
      hospitalIds: doctor.hospitals.map((hospital) => hospital._id), // Initialize selected hospitals
    }));
  };
  

  // Handle update of doctor details
  const handleUpdateDoctor = async (e) => {
    e.preventDefault();
    try {
      // Add the image in the update request if it's provided
      console.log(updatedName);
      const response = await axios.put(
        `https://api.swasthmitra.com/api/doctor/updatedoctor/${editingDoctor._id}`,
        {
          name: updatedName,
          image: updatedImage,
          hospitals:doctorData.hospitalIds,
        },
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      console.log(response.data);
      alert("Doctor updated successfully!");
      setEditingDoctor(null); // Close modal
      fetchDoctors(); // Refresh the list
    } catch (err) {
      alert("Failed to update doctor. Please try again.");
    }
  };

  useEffect(() => {
    fetchDoctors();
  }, []);

  if (loading) return <p>Loading doctors...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="doctor-management-container">
      <h2>Doctor Management</h2>
      {message && (
        <div className={`doctor-form-message ${message.type}`}>
          {message.text}
        </div>
      )}
      {doctors.length === 0 ? (
        <p>No doctors found.</p>
      ) : (
        <table className="doctor-table">
          <thead>
            <tr>
              <th>Image</th> {/* New column for image */}
              <th>Name</th>
              <th>Expertise</th>
              <th>Hospitals</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {doctors.map((doctor) => (
              <tr key={doctor._id}>
                <td>
                  <img
                    src={doctor.imageUrl || "default-image-url.jpg"} // Display default image if none exists
                    alt={doctor.name}
                    className="doctor-image"
                  />
                </td>
                <td>{doctor.name}</td>
                <td>{doctor.specialization}</td>
                <td>
                  {doctor?.hospitals
                    ?.map((hospital) => hospital.name)
                    .join(", ")}
                </td>
                <td>
                  <button onClick={() => openEditModal(doctor)}>Edit</button>
                  <button onClick={() => deleteDoctor(doctor._id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Modal for editing doctor */}
      {editingDoctor && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Edit Doctor</h3>
            <form onSubmit={handleUpdateDoctor}>
              <div>
                <label>Name</label>
                <input
                  type="text"
                  value={updatedName}
                  onChange={(e) => setUpdatedName(e.target.value)}
                  required
                />
              </div>
              <div>
                <label>Expertise</label>
                <input
                  type="text"
                  value={editingDoctor.specialization}
                  disabled
                  onChange={(e) => setUpdatedExpertise(e.target.value)}
                  required
                />
              </div>
              <div>
                <div>
                  <label>Hospitals</label>
                  <div className="hospital-tabs-container">
                    {editingDoctor?.hospitals?.map((hospital, index) => (
                      <div key={index} className="hospital-tab">
                        <span>{hospital.name}</span>
                        <span
                          onClick={() =>
                            handleDeleteHospital(
                              index,
                              hospital._id,
                              editingDoctor._id
                            )
                          }
                          className="delete-icon"
                        >
                          &#10006; {/* Cross Icon */}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="doctor-form-group">
  <label>Select Hospitals</label>
  <div className="doctor-dropdown-container">
    <button
      type="button"
      className="doctor-dropdown-button"
      onClick={() => setDropdownOpen(!dropdownOpen)}
    >
      {doctorData.hospitalIds.length > 0
        ? `${doctorData.hospitalIds.length} Selected`
        : "Select Hospitals"}
    </button>
    {dropdownOpen && (
      <div className="doctor-dropdown-menu">
        {hospitals.map((hospital) => (
          <label key={hospital._id} className="doctor-dropdown-item">
            <input
              className="doctor-checkbox"
              type="checkbox"
              value={hospital._id}
              name={hospital._id}
              checked={doctorData.hospitalIds.includes(hospital._id)}
              onChange={() => handleCheckboxChange(hospital._id)}
            />
            <span className="doctor-hospital-name">
              {hospital.name}
            </span>
          </label>
        ))}
      </div>
    )}
  </div>
</div>

              <div>
                <label>Image</label>
                <input
                  type="file"
                  onChange={(e) => setUpdatedImage(e.target.files[0])}
                />
              </div>
              <div>
                <button type="submit">Update</button>
                <button type="button" onClick={() => setEditingDoctor(null)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default DoctorManagement;
